import React, { useEffect, useState } from "react";
import { Typography, Stack, Container, Box, Card } from "@mui/material";
import MuiSearch from "../../components/muisearch";
import CardContent from "@mui/material/CardContent";
import { getAPI } from "../../services/basehttpAPI";
import * as BusinessConst from "../../utils/businessconstants";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { IconButton } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import MuiChip from "../../components/muichip";
import { formatDate } from "../../utils/utils";
import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";
import { visuallyHidden } from "@mui/utils";
import SnackbarComponent from "../../components/snackbar";



const ShipmentList = () => {
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    //always pass id, label, align property
    const columnHeaders = [
        //{ id: "shipmentDeliveryDetailsId", label: "", align: "left", enableSort: true },
        { id: "customerOrderId", label: translatedText?.customer_order_id, align: "left", enableSort: true },
        { id: "shipToName1", label: translatedText?.ship_to_name, align: "left", enableSort: true, style: "bold", },
        { id: "indasOrderId", label: translatedText?.indas_order_id, align: "left", enableSort: true },
        { id: "deliveryId", label: translatedText?.delivery_id, align: "left", enableSort: true },
        { id: "deliveryStatus", label: translatedText?.delivery_status, align: "left", enableSort: true },
        { id: "podStatus", label: translatedText?.pod_status, align: "left", enableSort: true },
        { id: "createdOnDate", label: translatedText?.created_date, align: "left", enableSort: true },
        { id: "updatedOnDate", label: translatedText?.updated_date, align: "left", enableSort: true },
        { id: "action", label: translatedText?.action, align: "left", pagekey: BusinessConst.pagekey_shipmentlist, enableSort: false },
    ];
  const [initialData, setInitialData] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [totalRecord, setTotalRecord] = useState([]);
    const [searchValue, setSearchValue] = useState(() => sessionStorage.getItem("shipmentlist_SearchKeyword") || "");
    const [page, setPage] = useState(() => parseInt(sessionStorage.getItem("page")) || 0);
    const [rowsPerPage, setRowsPerPage] = useState(() => parseInt(sessionStorage.getItem("rowsPerPage")) || 25);
    const navigate = useNavigate();
    const [isPageLoaded, setIsPageLoaded] = useState(true);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("id");
    const [open, setOpen] = useState(false);
    const [message, setmessage] = useState(null);
    const [severity, setseverity] = useState(null);
    const location = useLocation();

    const getAllShipments = async () => {
        let url = "ShipmentDetails/GetAllShipmentDeliveryDetails?pageNumber=" + page + "&pageRecords=" + rowsPerPage + "&searchValue=" + searchValue;
        const response = await getAPI(url, null);
        setInitialData(response?.responseData?.deliveryDetailsList);
        setDataList(response?.responseData?.deliveryDetailsList);
        setTotalRecord(response?.responseData?.totalListCount);
    };

    useEffect(() => {
        if(location.state?.Snackbaropen){
            setseverity("success");
            setmessage("Login Successfull");
            setOpen(true);
            navigate({
                state: {
                  Snackbaropen: false,
                }
              });
        }
    }, [location.state]);

    useEffect(() => {
        visibleRows();
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order, orderBy]);

    useEffect(() => {
        getAllShipments();
        sessionStorage.setItem("page", page);
        sessionStorage.setItem("rowsPerPage", rowsPerPage);
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (isPageLoaded) {
            setIsPageLoaded(false);
        } else {
            setPage(0);
        }
        getAllShipments();
        sessionStorage.setItem("shipmentlist_SearchKeyword", searchValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const handleClick = (id, pagekey) => {
        navigate(`/layout/viewshipment/${id}`);
    };
    const handleClickforShipmentList = (shipmentId, DeliveryId) => {
        navigate(`/layout/viewshipment/${shipmentId}/${DeliveryId}`);
    }

    const visibleRows = () => setDataList(stableSort(dataList, getComparator(order, orderBy)));

    const handleClose = () => {
        setOpen(false);
      };

    const filterData = (searchValue) => {
        if (searchValue === "") {
            return initialData;
        }
        return initialData.filter(
            (d) =>
                d.customerOrderId.toLowerCase().includes(searchValue.toLowerCase()) ||
                d.shipToName1.toLowerCase().includes(searchValue.toLowerCase()) ||
                d.indasOrderId.toLowerCase().includes(searchValue.toLowerCase()) ||
                d.deliveryId.toLowerCase().includes(searchValue.toLowerCase()) ||
                d.deliveryStatus.toLowerCase().includes(searchValue.toLowerCase()) ||
                d.podStatus.toLowerCase().includes(searchValue.toLowerCase())
        );
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.light.main,
            color: "#464F60",
            fontWeight: 600,
            fontSize: 10.8
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
        },
        paddingRight: "0px",
        padding: "6px"
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(even)": {
            backgroundColor: theme.palette.light.light,
        },
    }));

    const StyledPagination = styled(TablePagination)(({ theme }) => ({
        backgroundColor: theme.palette.light.main,
        color: theme.palette.common.black,
    }));

    function descendingComparator(a, b, orderBy) {
        let x =
            typeof b[orderBy] === "string" ? b[orderBy].toLowerCase() : b[orderBy];
        let y =
            typeof a[orderBy] === "string" ? a[orderBy].toLowerCase() : a[orderBy];
        if (x < y) {
            return -1;
        }
        if (x > y) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort, headerCells } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {headerCells.map((headCell) => (
                        <StyledTableCell
                            key={headCell.id}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={
                                    headCell.enableSort ? createSortHandler(headCell.id) : null
                                }
                            >
                                {headCell.label}
                                {headCell.enableSort && orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </StyledTableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.oneOf(["asc", "desc"]).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

  return dataList?.length > 0 ? (
    <>
      <Container maxWidth="xl">
        <Stack direction="row" spacing={2} paddingBottom={"30px"}>
          <Typography variant="h5" flexGrow={1}>
                      {" "}
                      {translatedText?.all_shipments}
          </Typography>
        </Stack>
        <Box>
                  <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} initialValue={searchValue} />
                  {/*<MuiDataTable headerdata={columnHeaders} rowData={dataList} rowLength={dataList.length} />*/}
                  <Paper sx={{ width: "100%" }}>
                      <TableContainer sx={{ height: "100%", overflow: "hidden" }}>
                          <Table stickyHeader aria-label="sticky table">
                              <EnhancedTableHead
                                  headerCells={columnHeaders}
                                  order={order}
                                  orderBy={orderBy}
                                  onRequestSort={handleRequestSort}
                                  rowCount={dataList.length}
                              />
                              <TableBody>
                                  {dataList.map((row) => {
                                      return (
                                          <StyledTableRow hover tabIndex={-1} key={row.id}>
                                              {columnHeaders.map((column) => {
                                                  const value = row[column.id];
                                                  return (
                                                      <TableCell key={column.id} align={column.align} sx={{ fontSize: "12px", padding: "6px" }}>
                                                          {(column.id === "action" && column.pagekey === BusinessConst.pagekey_shipmentlist) ? (
                                                              <IconButton onClick={() => handleClickforShipmentList(row.shipmentDetailsId, row.shipmentDeliveryDetailsId)}
                                                                  sx={{ color: "#2F80ED" }}>
                                                                  <Visibility /> </IconButton>)
                                                              : (column.id === "action") ? (
                                                                  <IconButton onClick={() => handleClick(row.id, column.pagekey)} sx={{ color: "#2F80ED" }}>
                                                                      <Visibility /> </IconButton>)
                                                                  : column.id === "isActive" || column.id === "deliveryStatus" || column.id === "podStatus" ? (
                                                                      <MuiChip row={row} statusKey={column.id}> </MuiChip>)
                                                                      : (column.id === "lastLogin" || column.id === "createdOnDate" || column.id === "updatedOnDate") ? (
                                                                          formatDate(value))
                                                                          : column.style === "bold" ? (<b>{value}</b>)
                                                                              : (value)
                                                          }
                                                      </TableCell>
                                                  );
                                              })}
                                          </StyledTableRow>
                                      );
                                  })}
                              </TableBody>
                          </Table>
                      </TableContainer>
                      <StyledPagination
                          rowsPerPageOptions={[25, 50, 100]}
                          component="div"
                          count={totalRecord}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                  </Paper>
        </Box>
      </Container>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </>
  ) : (<>
    <Container maxWidth="xl">
      <Stack direction="row" spacing={2} paddingBottom={"30px"}>
        <Typography variant="h5" flexGrow={1}>
          {" "}
          {translatedText?.all_shipments}
        </Typography>
      </Stack>
      <Box>
        <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} initialValue={searchValue} />
      </Box>
      <Card>
        <CardContent>
          <Typography variant="h6" align="center" component="div">
                          {translatedText?.no_records_found}
          </Typography>
        </CardContent>
      </Card>
    </Container>
  </>);
};


export default ShipmentList
